import FloatBox from './floatbox';

export default FloatBox;



// WEBPACK FOOTER //
// ./src/components/floatbox/index.js